import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=3cb7e2ee&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb7e2ee')) {
      api.createRecord('3cb7e2ee', component.options)
    } else {
      api.reload('3cb7e2ee', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=3cb7e2ee&", function () {
      api.rerender('3cb7e2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/MainLayout.vue"
export default component.exports